export const CATALOG_KDC_BANNER_HEADLINE = {
  mobile: '최대 2개 기초 국비강의 보러 가기',
  laptop: '최대 두 개까지 국비지원되는 기초 강의 들으러 가기!',
}

export const CATALOG_NEBECA_BANNER_HEADLINE = {
  mobile: '내일배움카드가 없다면?',
  laptop: '내일배움카드 신청하고 국비지원 혜택으로 멋사교육 들으러 가기',
}

export const CATALOG_SORT_OPTIONS = [
  { value: '-order', label: '인기순' },
  { value: '-created_at', label: '최신순' },
] as const
